module.exports = __webpack_public_path__ + "img/img26.2a415776.png";